// extracted by mini-css-extract-plugin
module.exports = {"sell":"styles_sell__29q7-","buy":"styles_buy__1ILPQ"};